import { render, staticRenderFns } from "./FirmDocumentContent.vue?vue&type=template&id=640b8249&"
import script from "./FirmDocumentContent.vue?vue&type=script&lang=ts&"
export * from "./FirmDocumentContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports